import React, { useState } from "react";
import axios from "axios";
import Select from "react-select";
import Geocode from "react-geocode";

// Initialize Google Geocoding API
Geocode.setApiKey("AIzaSyClbig43rDJiDAjE8QVefX2LNZpczeBt5w");
Geocode.setLanguage("en");
Geocode.setLocationType("ROOFTOP");

const GeoSearchAutocomplete = () => {
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]); // Store multiple addresses
  
  const handleSearch = async (inputValue) => {
    if (!inputValue) return;

    try {
      const response = await Geocode.fromAddress(`${inputValue}, Bengaluru`);
      const results = response.results;

      const formattedOptions = results.slice(0, 5).map((result) => ({
        value: result.geometry.location,
        label: result.formatted_address,
      }));

      setOptions(formattedOptions);
    } catch (error) {
      console.error("Error fetching geocode data:", error);
    }
  };

  const handleInputChange = (inputValue) => {
    handleSearch(inputValue);
  };

  const handleChange = (options) => {
    setSelectedOptions(options); // Store multiple selected options
    console.log("Selected locations:", options);
  };

  return (
    <div style={{ width: "400px", margin: "0 auto" }}>
      <h3>GeoSearch Autocomplete (Multiple Addresses)</h3>
      <Select
        options={options}
        isMulti // Enable multiple selection
        onInputChange={handleInputChange}
        onChange={handleChange}
        placeholder="Search and select multiple locations in India..."
      />
      {selectedOptions.length > 0 && (
        <div>
          <h4>Selected Locations:</h4>
          <ul>
            {selectedOptions.map((option, index) => (
              <li key={index}>
                <strong>{option.label}</strong> (Lat: {option.value.lat}, Lng:{" "}
                {option.value.lng})
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default GeoSearchAutocomplete;
